export default {
  creditCard: require('./new-update-payment.jpg'),
  debtPayment: require('./debt-payment.svg'),
  invoices: require('./invoices.svg'),
  creditCardPurple: require('./new-payment.jpg'),
  debtPaymentPurple: require('./new-update-payment.jpg'),
  invoicesPurple: require('./new-invoce.jpg'),
  personalInfo: require('./personal-info.svg'),
  changeSim: require('./change-sim.svg'),
  dataUsage: require('./data-usage.svg'),
  error: require('./error.svg'),
  arrow: require('./arrow-left.svg'),
  background: require('./background.png'),
  arrowDown: require('./arrow-down.svg'),
  abroadBusinessIndividual: require('./abroad.svg'),
  deviceRepair: require('./device.svg'),
  suspentAccount: require('./suspend.svg'),
  likeIcon: require('./icon-like/icon-100-like.svg'),
  insightIcon: require('./icon-insight/icon-120-insight.svg'),
  errorIcon: require('./icon-error/icon-120-error.svg'),
  ccrIcon: require('./ccr-icon.svg'),
  uploadUserLIstIcon: require('./upload_user_list.svg'),
  businessReports: require('./business-reports.svg'),
  transferBusinessAccount: require('./transferAccount.svg'),
  retriveQRCode: require('./retrive-qr-code.svg'),
  ownershipTransfer: require('./ownershipTransfer.svg'),
  reportManagement: require('./reportManagement.svg'),
};
